import styled from 'styled-components'

export const MyMembershipWidgetContainer = styled.div`
  background: linear-gradient(135deg, #e8dfd8 0%, #d4c4b5 50%, #c9b8a8 100%);
  width: 100%;
  display: flex;
  border-radius: 14px;
  margin-bottom: 24px;
  overflow: hidden;
  padding: 16px 12px;
  flex-direction: column;
  gap: 20px;
  border: 1px solid rgba(139, 104, 92, 0.15);
  box-shadow: 0 4px 24px rgba(139, 104, 92, 0.12);

  @media (min-width: 480px) {
    padding: 24px 20px;
    gap: 24px;
    border-radius: 16px;
  }
  @media (min-width: 768px) {
    border-radius: 20px;
    padding: 36px 40px;
    flex-direction: row;
    gap: 40px;
    box-shadow: 0 8px 32px rgba(139, 104, 92, 0.15);
  }
`

// titles, descriptions

export const MyMembershipWidgetHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 20px;
  @media (min-width: 768px) {
    text-align: left;
  }
`

export const MyMembershipWidgetHeading = styled.div`
  color: ${(props) => (props?.main ? '#1f1b18' : '#6b5b52')};
  font-size: ${(props) => (props?.main ? '22px' : '14px')};
  font-weight: ${(props) => (props?.main ? '700' : '500')};
  letter-spacing: ${(props) => (props?.main ? '-0.02em' : '0')};
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.main ? '26px' : '16px')};
    max-width: 200px;
  }
`

// items in membership widget :

export const MyMembershipWidgetItemsParent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (min-width: 480px) {
    gap: 24px;
  }
  @media (min-width: 768px) {
    gap: 35px;
    justify-content: left;
  }
`

export const MyMembershipWidgetExtraItem = styled.div`
  background: #ffe0cb;
  border-radius: 28px;
  width: 157px;
  height: 152px;
  display: flex;
  cursor: default;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #7f4722;
  font-size: 14px;
  font-weight: 400;
  @media (min-width: 768px) {
    width: 220px;
    height: 210px;
    gap: 15px;
    font-size: 20px;
  }
`

export const MyMembershipWidgetExtraItemButton = styled.button`
  color: #fff;
  text-align: center;
  background: linear-gradient(147deg, #6977df 0%, #ca98ff 100%);
  box-shadow: 1px 2px 12px 0px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  width: 120px;
  font-weight: 500;
  font-size: 15px;
  padding: 3px 0;
  @media (min-width: 768px) {
    border-radius: 36px;
    width: 150px;
    font-weight: 600;
    font-size: 18px;
    padding: 6px 0;
  }
`

export const MyMembershipWidgetItemImgAndItemContainer = styled.div`
  cursor: default;
  position: relative;
`

export const MyMembershipWidgetItemImageContainer = styled.div`
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  border-radius: 10px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.4);

  @media (min-width: 480px) {
    width: 48px;
    height: 48px;
    top: -24px;
    left: 52px;
    transform: none;
  }
  @media (min-width: 768px) {
    margin: 0 0 0 28px;
    left: 0;
    width: 54px;
    height: 54px;
    top: -27px;
  }
`

export const MyMembershipWidgetItemImage = styled.img`
  height: 60%;
  width: 60%;
`

export const MyMembershipWidgetItemContainer = styled.div`
  position: relative;
  flex-shrink: 0;
  background: linear-gradient(180deg, #e8e8e8 0%, #d4d4d4 100%);
  overflow: hidden;
  border-radius: 16px;
  width: 140px;
  height: 135px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);

  @media (min-width: 480px) {
    width: 157px;
    height: 152px;
    border-radius: 20px;
  }
  @media (min-width: 768px) {
    width: 220px;
    height: 210px;
    border-radius: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
`

export const WidgetItemProgressColor = styled.div`
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${(props) => `${props?.programRequestedWidth}%`};
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.2);
  transition: width 0.4s ease;
`

export const MyMembershipWidgetDetailsContainer = styled.div`
  background: linear-gradient(180deg, #fefcfb 0%, #f8f3ef 100%);
  position: absolute;
  top: 0;
  left: 0;
  height: ${(props) => (props?.coverFullHeight ? '100%' : 'calc(100% - 12px)')};
  width: 100%;
  border-radius: 0 0 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 28px 12px 20px;

  @media (min-width: 768px) {
    border-radius: 0 0 24px 24px;
    align-items: flex-start;
    padding: 40px 24px 24px;
  }
`
export const MyMembershipMembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  @media (min-width: 768px) {
    align-items: flex-start;
    justify-content: flex-end;
  }
`

export const MyMembershipWidgetDetailsItemHeading = styled.div`
  color: #5a5a5a;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  @media (min-width: 768px) {
    font-size: 17px;
    text-align: left;
    line-height: 1.5;
  }
`

export const MyMembershipWidgetDetailStat = styled.div`
  color: #4a3728;
  font-size: ${(props) => (props?.big ? '26px' : '12px')};
  font-weight: ${(props) => (props?.big ? '700' : '500')};
  letter-spacing: ${(props) => (props?.big ? '-0.02em' : '0')};
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.big ? '32px' : '13px')};
  }
`
